/**
 * Centralized registry of dashboard module types
 *
 * Defines available modules metadata (no renderers to avoid import issues in tests).
 *
 * @module dashboard/modules/registry
 */

import { TableChart, NetworkPing, SelectAll, Timeline, AutoAwesome } from "@mui/icons-material"
import { MODULE_TYPES, ModuleDefinition, ModuleType } from "./types"

export const MODULE_REGISTRY = {
  [MODULE_TYPES.ASSET_VIEW]: {
    type: MODULE_TYPES.ASSET_VIEW,
    title: "Asset View",
    icon: TableChart,
    removable: false,
    editable: true,
    description: "View detailed asset information and holdings",
  },

  [MODULE_TYPES.KPI]: {
    type: MODULE_TYPES.KPI,
    title: "KPI",
    icon: NetworkPing,
    removable: false,
    editable: true,
    description: "Key performance indicators and metrics",
  },

  [MODULE_TYPES.GRAPH]: {
    type: MODULE_TYPES.GRAPH,
    title: "Graph",
    icon: Timeline,
    removable: false,
    editable: true,
    description: "Performance charts and visualizations",
  },

  [MODULE_TYPES.FACTORS]: {
    type: MODULE_TYPES.FACTORS,
    title: "Factors",
    icon: SelectAll,
    removable: false,
    editable: true,
    description: "Factor analysis and attribution",
  },

  [MODULE_TYPES.AI_ARTIFACT]: {
    type: MODULE_TYPES.AI_ARTIFACT,
    title: "AI Artifact",
    icon: AutoAwesome,
    removable: true,
    editable: true,
    removeRequiresConfirmation: true,
    description: "AI-generated plots and tables from AI Teammate",
  },
}

export function isModuleTypeRegistered(moduleType: string): moduleType is ModuleType {
  return moduleType in MODULE_REGISTRY
}

export function getModuleDefinition(moduleType: ModuleType): ModuleDefinition {
  const definition = MODULE_REGISTRY[moduleType]
  if (!definition) {
    throw new Error(`Unknown module type: ${moduleType}`)
  }
  return definition
}
